import { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { Link } from 'react-router-dom';

import { INotification } from 'CorePackage/NotificationModule/interfaces/INotification';
import { NoticeTypesEnum } from 'CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { CLOSE_TIMEOUT, KNM_EXPORT_SUCCESS } from 'CorePackage/MainModule/constants/notices';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { ROUTE_TEMPLATES_EXPORT } from 'CorePackage/MainModule/routes/routes';

import styles from './Notification.module.scss';
import { removeNoticeAction } from '../actions/NoticeActions';
import { MessageTypesEnum } from '../enums/MessageTypesEnum';

interface INotificationProps {
  removeNotice: (id: string) => void;
  close?: () => void;
  notice: INotification;
}

const NotificationWithoutStore = ({ removeNotice, notice, close }: INotificationProps) => {
  const closeNotice = useCallback(() => {
    if (close) {
      return close();
    }
    removeNotice(notice.id ?? '');
  }, [removeNotice, notice, close]);

  useEffect(() => {
    let timeoutId: number | undefined;

    if (notice.noticeType === NoticeTypesEnum.SUCCESS) {
      timeoutId = window.setTimeout(closeNotice, CLOSE_TIMEOUT);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [closeNotice, notice]);

  return (
    <div className={styles.Notification} data-type={notice.noticeType}>
      <div className={styles.ClosingNotificationText}>
        {notice.messageType === MessageTypesEnum.EXPORT &&
        notice.noticeType === NoticeTypesEnum.SUCCESS &&
        notice.exportId ? (
          <>
            {KNM_EXPORT_SUCCESS}&nbsp;
            <Link to={ROUTE_TEMPLATES_EXPORT} className={styles.NotificationLink}>
              {notice.exportId}
            </Link>
          </>
        ) : (
          notice.renderContent
        )}
      </div>
      <button className={styles.CloseButton} type="button" onClick={closeNotice}>
        ×
      </button>
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<RootActions>) => ({
  removeNotice: (id: string) => dispatch(removeNoticeAction(id)),
});

export const Notification = connect(null, mapDispatchToProps)(NotificationWithoutStore);
